export const BOM_AUTO_URL_PROVIDERS = Object.freeze([
  Object.freeze({
    key: 'amazon',
    label: 'Amazon',
    buildSearchUrl: (query) => `https://www.amazon.com/s?k=${query}`
  }),
  Object.freeze({
    key: 'aliexpress',
    label: 'AliExpress',
    buildSearchUrl: (query) => `https://www.aliexpress.com/wholesale?SearchText=${query}`
  }),
  Object.freeze({
    key: 'digikey',
    label: 'DigiKey',
    buildSearchUrl: (query) => `https://www.digikey.com/en/products/result?keywords=${query}`
  }),
  Object.freeze({
    key: 'pcbway',
    label: 'PCBWay',
    buildSearchUrl: (query) => `https://www.pcbway.com/project/projectsearch?q=${query}`
  }),
  Object.freeze({
    key: 'mouser',
    label: 'Mouser',
    buildSearchUrl: (query) => `https://www.mouser.com/c/?q=${query}`
  })
]);

export const BOM_AUTO_URL_PROVIDER_MAP = Object.freeze(
  BOM_AUTO_URL_PROVIDERS.reduce((acc, provider) => {
    acc[provider.key] = provider;
    return acc;
  }, {})
);

export const BOM_AUTO_URL_PROVIDER_KEYS = new Set(
  BOM_AUTO_URL_PROVIDERS.map((provider) => provider.key)
);
